import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchActivityReport, fetchChildBillReport, fetchChildCheckInOut, fetchChildrenReport, fetchCurriculumReport, fetchEventReport, fetchHrPayrollReport, fetchIncidentBehaviorsReport, fetchMealReport, fetchNewsLetterReport, fetchRoomReport, fetchStaffCheckInOut, fetchStaffReport } from "../../../service/api";


export const getStaffCheckInOut = createAsyncThunk(
    "report/staffCheckin",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffCheckInOut(params)
            console.log("staff check in", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getChildrenCheckInOut = createAsyncThunk(
    "report/checkInOut",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildCheckInOut(params)
            console.log("staff check in", response)
            return response.data
        } catch (error) {
            console.log("error", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getCurriculumReport = createAsyncThunk(
    "report/curriculum",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchCurriculumReport(params)
            console.log("staff check in", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getEventReport = createAsyncThunk(
    "report/events",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchEventReport(params)
            console.log("event report", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getMealReport = createAsyncThunk(
    "report/meal",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMealReport(params)
            console.log("meal report", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getRoomReport = createAsyncThunk(
    "report/room",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchRoomReport(params)
            console.log("room report", response)
            return response.data
        } catch (error) {
            console.log(error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getChildrenReport = createAsyncThunk(
    "report/child",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildrenReport(params)
            console.log("child report", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getNewsLetterReport = createAsyncThunk(
    "report/newsLetter",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchNewsLetterReport(params)
            console.log("news report", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getStaffReport = createAsyncThunk(
    "report/staff",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffReport(params)
            console.log("staff report", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getIncidentBehaviorsReport = createAsyncThunk(
    "report/IncidentBehaviors",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchIncidentBehaviorsReport(params)
            console.log("incident report", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getActivityReport = createAsyncThunk(
    "report/activity",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchActivityReport(params)
            console.log("activity report", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getChildBillReport = createAsyncThunk(
    "report/bill",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchChildBillReport(params)
            console.log("bill report", response)
            return response.data
        } catch (error) {
            console.log("bill report", error)

            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getStaffPayrollReport = createAsyncThunk(
    "report/payroll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchHrPayrollReport(params)
            console.log("payroll report", response)
            return response.data
        } catch (error) {
            console.log("bill report", error)
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)



const reportSlice = createSlice({
    name: "reports",
    initialState: {
        actionLoader: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            //GET STAFF  IN OUT
            .addCase(getStaffCheckInOut.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getStaffCheckInOut.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getStaffCheckInOut.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET CHILD  IN OUT
            .addCase(getChildrenCheckInOut.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getChildrenCheckInOut.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getChildrenCheckInOut.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET CURRICULUM
            .addCase(getCurriculumReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getCurriculumReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getCurriculumReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET EVENTS
            .addCase(getEventReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getEventReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getEventReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET MEALS
            .addCase(getMealReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getMealReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getMealReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })


            //GET ROOM
            .addCase(getRoomReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getRoomReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getRoomReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET CHILD
            .addCase(getChildrenReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getChildrenReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getChildrenReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })


            //GET NEWS
            .addCase(getNewsLetterReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getNewsLetterReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getNewsLetterReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET STAFF
            .addCase(getStaffReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getStaffReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getStaffReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET INCIDENT
            .addCase(getIncidentBehaviorsReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getIncidentBehaviorsReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getIncidentBehaviorsReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //GET ACTIVITY
            .addCase(getActivityReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getActivityReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getActivityReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

             //GET BILL
            .addCase(getChildBillReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getChildBillReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getChildBillReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

             //GET PAYROLL
            .addCase(getStaffPayrollReport.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(getStaffPayrollReport.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(getStaffPayrollReport.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })


    }
})
export default reportSlice.reducer;